<template>
  <f7-page no-toolbar no-swipeback name="sign-in" class="page-sign-in">
    <f7-navbar :title="$t('v1_sign_in_0001')" back-link :no-hariline="true"></f7-navbar>
    <div class="mynews">
    <div class="buttons-tab buttons-signIn">
      <f7-link tab-link="#tab-signIn-center" tab-link-active :text="$t('v1_sign_in_0002')"></f7-link>
      <f7-link tab-link="#tab-signIn-instructions" :text="$t('v1_sign_in_0003')"></f7-link>
    </div>
    <f7-tabs swipeable class="tabs-signIn">
      <f7-tab id="tab-signIn-center" class="page-content tab-signIn-center" tab-active>
        <f7-block class="block-signIn">
          <div class="signIn-calendar-card">
            <div class="signIn-calendar-head">
              <div class="current-date"></div>
            </div>
            <div class="signIn-main" id="js-signIn-main">
              <div class="header">
                <div>{{ $t('v1_sign_in_0006') }}</div>
                <div>{{ $t('v1_sign_in_0007') }}</div>
                <div>{{ $t('v1_sign_in_0008') }}</div>
                <div>{{ $t('v1_sign_in_0009') }}</div>
                <div>{{ $t('v1_sign_in_0010') }}</div>
                <div>{{ $t('v1_sign_in_0011') }}</div>
                <div>{{ $t('v1_sign_in_0012') }}</div>
              </div>
              <ul class="signIn-list" id="js-signIn-list"></ul>
            </div>
          </div>

          <f7-list inset class="button-signIn" :class="{'disabled-status': buttonSinginStatus}">
            <f7-list-button :title="buttonSinginStatus ? $t('v1_sign_in_0033') : $t('v1_sign_in_0013')" @click="signInEvent"></f7-list-button>
          </f7-list>

          <div class="history" v-show="signindetaildaytimelist.length>0">
            <div class="history-head">
              <span class="history-title">{{ $t('v1_sign_in_0031') }}</span>
            </div>
            <div class="history-card" v-for="(item, index) in signindetaildaytimelist" :key="index">
              <div class="history-icon-wrap">
                <div ><img src="../../../static/images/yt999/newss/signin/checkin.png" alt="" width="17px"></div>
              </div>
              <div class="history-main">
                <div class="history-name">{{ $t('v1_sign_in_0032') }}</div>
                <div class="history-time">{{ item.CreateTS | time2 }}</div>
              </div>
              <div class="history-side">
                <div class="history-points" v-show="item.SignInAmount>0">{{ $t("v1_sign_in_0028") }}(+{{ item.SignInAmount | formatCurrency }})</div>
                <div class="history-points" v-show="item.BonusPoint>0">{{ $t("v1_sign_in_0029") }}(+{{ item.BonusPoint }})</div>
                <!-- <div class="history-status">{{ 33 }}</div> -->
              </div>
            </div>
          </div>
        </f7-block>
      </f7-tab>
      <f7-tab id="tab-signIn-instructions" class="page-content tab-signIn-instructions">
        <f7-block>
          <div v-html="dailySignInRemark"></div>
        </f7-block>
      </f7-tab>
    </f7-tabs>
    </div>


  <van-popup v-model="vanflag" class="van" >
    <div class="">
      <div><img :src="`../../../static/images/yt999/home/ico/lihua.png`" class="hua" height="90px" /></div>
      <div class="f1" >
        <span style="font-size: 22px;">{{ $t("v1_sign_in_0030") }}</span>
      </div>
    
      <div class="ocontent" >
        <div class="tiao" v-if="backData.SignInAmount>0">
          <img  src="../../../static/images/yt999/home/ico/b1.png" alt="" srcset="">{{ $t("v1_sign_in_0028") }}(+<span style="color:red;">{{ backData.SignInAmount | formatCurrency }}</span>)
        </div>
        <div class="tiao" v-if="backData.BonusPoint>0">
          <img  src="../../../static/images/yt999/home/ico/b2.png" alt="" srcset="">{{ $t("v1_sign_in_0029") }}(+<span style="color:red;">{{ backData.BonusPoint  }}</span>)
        </div>
      </div>

      <div class="go" @click="vanflag = false;">{{ $t("common_0001") }}</div>
    </div>
  </van-popup>
  </f7-page>
</template>

<script>
import {
  getUserInfo,
  getVipsigninsettinglist,
  signIn,
  getUsernameSignindetailDay,
  getwebsiteinfoGet,
  membersignindetaildaytimelist
} from "../../../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      dailySettingList: [],
      dailyAmount: 0,
      dailyLevelName: "",
      userLevelName: "",
      usernameSignindetailDay: [],
      usernameSignindetailDayMoney: 0,
      buttonSinginStatus: false,

      vanflag: false,
      backData: {SignInAmount: 0, BonusPoint: 0},
      dailySignInRemark: "",
      signindetaildaytimelist: [],
    };
  },
  watch: {},
  computed: {

  },
  methods: {
    
    membersignindetaildaytimelist(){
      const self = this;
      membersignindetaildaytimelist().then((data) => {
        if (data.Code === "NoError") {
          self.signindetaildaytimelist= data.Data;
        }
      });
    },
    getwebsiteinfoGet(){
      const self = this;
      getwebsiteinfoGet().then((data) => {
        if (data.Code === "NoError") {
          self.dailySignInRemark= data.Data.DailySignInRemark;
        }
      });
    },
    userInfo() {
      const self = this;
      getUserInfo().then(data => {
        if (data.Code === "NoError") {
          self.userLevelName = data.Data.VipLevelName;
          self.signInSettingList();
        }
      });
    },
    signInSettingList() {
      const self = this;
      getVipsigninsettinglist().then(data => {
        if (data.Code === "NoError") {
          self.dailySettingList = data.Data;
          data.Data.forEach(item => {
            if (self.userLevelName === item.Name) {
              self.dailyAmount = item.DailyAmount;
              self.dailyLevelName = self.userLevelName;
            }
          });
        }
      });
    },
    signInEvent() {
      const self = this;
      if (self.buttonSinginStatus) return;
      signIn().then(data => {
        if (data.Code === "NoError") {
          self.vanflag = true;
          self.backData = data.Data;
          self.signInDetailDay(true);
          self.membersignindetaildaytimelist();
        }else{
          self.$f7.dialog.alert(data.Data, this.$t("common_0004"));
        }


      });
    },
    signInDetailDay(f) {
      const self = this;
      const param = { data: JSON.stringify({ Choose: f }) };
      getUsernameSignindetailDay(param).then(data => {
        if (data.Code === "NoError") {
          self.usernameSignindetailDay = data.Data[0];
          self.usernameSignindetailDayMoney = data.Data[1];
          self.buttonSinginStatus = data.Data[2];
          self.signCalendar(self.usernameSignindetailDay);
        }
      });
    },
    signCalendar(dayData) {
      const self = this;
      const $$ = self.$f7.$;
      let $dateBox = $$("#js-signIn-list"),
        $currentDate = $$(".current-date"),
        _html = "",
        _handle = true,
        myDate = new Date();
      // $currentDate.text(
      //   myDate.getFullYear() +
      //     this.$t('v1_sign_in_0026') +
      //     parseInt(myDate.getMonth() + 1) +
      //     this.$t('v1_sign_in_0027') +
      //     myDate.getDate() +
      //     this.$t('v1_sign_in_0006')
      // );
      let monthFirst = new Date(
        myDate.getFullYear(),
        parseInt(myDate.getMonth()),
        1
      ).getDay();
      let totalDay = new Date(
        myDate.getFullYear(),
        parseInt(myDate.getMonth() + 1),
        0
      ).getDate();
      let monthLast = new Date(
        myDate.getFullYear(),
        parseInt(myDate.getMonth()),
        totalDay
      ).getDay();
      let num1 = totalDay - (7 - monthFirst);
      let num2 = num1 - (monthLast + 1);
      let num3 = num2 / 7;
      let tableNum = (num3 + 2) * 7;
      for (let i = 0; i < tableNum; i++) {
        _html +=
          ' <li class="sign-date"><div class="signin-icon"></div><i></i></li>';
      }
      $dateBox.html(_html);
      let $dateLi = $dateBox.find("li");
      for (let i = 0; i < totalDay; i++) {
        $dateLi.eq(i + monthFirst).addClass("date" + parseInt(i + 1));
        let index = i + 1;
        if (dayData.indexOf(index) != -1) {
          $dateLi.eq(i + monthFirst).addClass("signIn-cls");
        }
      }
      let times = myDate.getDate();
      if (dayData.indexOf(times) != -1) {

      } else {
        $$(".date" + times).addClass("able-qiandao");

        $$(".able-qiandao").click(function() {
          //$scope.signIn();
          $$(".date" + times).removeClass("able-qiandao");
        });
      }
    }
  },
  created() {
    this.userInfo();
    this.signInDetailDay(false);
    this.getwebsiteinfoGet();
    this.membersignindetaildaytimelist();
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.ios .page-sign-in .buttons-signIn a.tab-link {

  text-align: center;
}
.history {
  margin-top: 18px;

  .history-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .history-title {
    color: #334155;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 1.1px;
  }

  .history-link {
    color: #2563eb;
    font-size: 12px;
    font-weight: 700;
  }

  .history-card {
    display: flex;
    align-items: center;
    padding: 14px 12px;
    border-radius: 16px;
    background: #f2f2f2;
    margin-bottom: 10px;
    // background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    // box-shadow: 0 12px 28px rgba(148, 163, 184, 0.16);
  }

  .history-icon-wrap {
    flex: 0 0 34px;
    width: 34px;
    height: 34px;
    margin-right: 12px;
    border-radius: 10px;
    background: linear-gradient(180deg, #eef4ff 0%, #dce9ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .history-icon {
    position: relative;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    background: #94a3b8;

    &:before {
      content: "";
      position: absolute;
      left: 3px;
      right: 3px;
      top: 5px;
      height: 2px;
      background: #fff;
      box-shadow: 0 4px 0 #fff;
    }

    &:after {
      content: "";
      position: absolute;
      top: -2px;
      left: 4px;
      width: 10px;
      height: 4px;
      border-radius: 3px 3px 0 0;
      border: 2px solid #94a3b8;
      border-bottom: 0;
      box-sizing: border-box;
    }
  }

  .history-main {
    flex: 1;
    min-width: 0;
  }

  .history-name {
    color: #334155;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.2;
  }

  .history-time {
    margin-top: 3px;
    color: #94a3b8;
    font-size: 11px;
    line-height: 1.2;
  }

  .history-side {
    margin-left: 10px;
    text-align: right;
  }

  .history-points {
    color: var(--f7-THEME-color);
    font-size: 11px;
    font-weight: 800;
    // line-height: 1.2;
    white-space: nowrap;
  }

  .history-status {
    margin-top: 4px;
    color: #22c55e;
    font-size: 10px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 0.8px;
  }
}

.van {
  width: 60%;
  border-radius: 20px;
  padding: 15px;
  overflow: initial;
  padding-top: 50px;
  .hua{
    position: absolute;
    top: -39px;
    z-index: 1000001;
    right: 0px;

  }
  .f1 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
  }
  .f3 {
    font-size: 20px;
    font-weight: bold;
    margin: 10px 0;
    color: var(--f7-THEME-color);
  }
  .go {
    height: 40px;
    line-height: 40px;
    background: var(--f7-THEME-color);
    margin: 20px auto 10px auto;
    border-radius: 25px;
    color: white;
    font-weight: bold;
    text-align: center;
  }
  .ocontent{
    .tiao{
      display: flex;
      align-items: center;
      margin-top: 10px;
      img{
        height: 18px;
        margin-right: 5px;
      }
    }
  }
}
</style>